export default {
  review: {
    submit: 'Transfer money',
    loading: 'Loading transfer review',
    details: 'Transfer details',
    invalidInputTitle: 'Check your transfer details',
    invalidInputMessage:
      'Choose a source, destination, and valid transfer amount before reviewing your transfer.',
    leaveTitle: 'Leave while your transfer is posting?',
    leaveMessage:
      'Your transfer will keep processing, but you won’t see the result here. You can check its status in your transfer history.',
    stay: 'Stay',
    leave: 'Leave',
  },
  processing: {
    title: 'We need a little more time',
    message:
      'The transfer is taking longer than expected. We’ll let you know when it’s complete.',
    done: 'Done',
  },
  success: {
    eyebrow: 'SUCCESS',
    transferredTitle: '{{amount}} transferred',
    scheduledTitle: '{{amount}} transfer scheduled',
    seeTransfers: 'See my transfers',
  },
  error: {
    title: 'We couldn’t complete your transfer',
    debitCardMessage:
      'Something went wrong. We couldn’t send money to this debit card. Choose a different account.',
    chooseDifferentAccount: 'Choose a different account',
    close: 'Close',
  },
  entry: {
    title: 'Transfer',
    account: 'Account',
    externalAccount: 'External account',
    availableBalance: 'Available: {{balance}}',
    source: 'From:',
    destination: 'To:',
    selectAccount: 'Choose an account',
    transferFrom: 'Transfer from',
    transferTo: 'Transfer to',
    reviewTransfer: 'Review transfer',
    sourceUnavailable: 'We could not load your accounts. Try again.',
    destinationUnavailable:
      'We could not load transfer destinations. Try again.',
    noEligibleSources: 'No accounts are eligible for this transfer.',
    limitsUnavailable: 'We could not load your transfer limits. Try again.',
    errorTitle: 'Something went wrong',
    transferUnavailableTitle: 'Transfer unavailable',
    transferUnavailableMessage: 'Transfers aren’t available right now.',
    goBack: 'Go back',
    retry: 'Try again',
    amount: 'Amount',
    speedWithFee: '{{speed}} • {{fee}}',
    amountExceedsTransactionLimit: 'Amount can’t be more than {{limit}}.',
    amountBelowMinimum: 'Amount must be at least {{limit}}.',
  },
};
